import { render, staticRenderFns } from "./JiCaiSupplierManage.vue?vue&type=template&id=60407ee8&scoped=true&"
import script from "./JiCaiSupplierManage.vue?vue&type=script&lang=js&"
export * from "./JiCaiSupplierManage.vue?vue&type=script&lang=js&"
import style0 from "./JiCaiSupplierManage.vue?vue&type=style&index=0&id=60407ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60407ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60407ee8')) {
      api.createRecord('60407ee8', component.options)
    } else {
      api.reload('60407ee8', component.options)
    }
    module.hot.accept("./JiCaiSupplierManage.vue?vue&type=template&id=60407ee8&scoped=true&", function () {
      api.rerender('60407ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/JiCaiSupplierManage.vue"
export default component.exports